import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wfdss-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}
